import React from "react";
import { Link } from "react-router-dom";
import { ScrollArea } from "../ui/scroll-area";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";
import { MessageCircle, Trash2 } from "lucide-react";

/**
 * Channel-chat moderation list — owner of the channel sees their viewers'
 * messages and can delete inappropriate ones. Stateless: parent owns the
 * fetch + delete handler.
 */
const ChannelChatTab = ({ messages, loading, onDelete }) => (
  <Card className="bg-gray-900 border-gray-800">
    <CardHeader className="p-4 sm:p-6">
      <CardTitle className="text-white text-base sm:text-lg flex items-center gap-2">
        <MessageCircle className="h-5 w-5 text-yellow-400" />
        Channel Chat Messages ({messages.length})
      </CardTitle>
      <CardDescription className="text-gray-400 text-xs sm:text-sm">
        Manage messages in your channel chat. Delete any inappropriate content.
      </CardDescription>
    </CardHeader>
    <CardContent className="p-4 sm:p-6 pt-0">
      <ScrollArea className="h-[400px]">
        {loading ? (
          <div className="flex justify-center py-8">
            <div className="animate-spin h-8 w-8 border-2 border-yellow-500 border-t-transparent rounded-full" />
          </div>
        ) : messages.length > 0 ? (
          <div className="space-y-3">
            {messages.map((msg) => (
              <div key={msg.id} className="flex items-start justify-between gap-3 p-3 bg-gray-800/50 rounded-lg">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <Link to={`/${msg.username}`} className="text-emerald-400 text-sm font-medium hover:underline">
                      @{msg.username}
                    </Link>
                    <span className="text-gray-500 text-xs">
                      {new Date(msg.created_at).toLocaleString()}
                    </span>
                  </div>
                  <p className="text-gray-300 text-sm">{msg.content}</p>
                </div>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => onDelete(msg.id)}
                  className="text-red-400 hover:text-red-300 hover:bg-red-500/10 shrink-0"
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <MessageCircle className="h-12 w-12 text-gray-600 mx-auto mb-3" />
            <p className="text-gray-400">No channel chat messages yet</p>
            <p className="text-gray-500 text-sm mt-1">Messages will appear when viewers chat on your channel</p>
          </div>
        )}
      </ScrollArea>
    </CardContent>
  </Card>
);

export default ChannelChatTab;
